export default __webpack_public_path__ + "static/media/Rectangle 14846.d0228ffe.png";